import { collection, addDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";

export const addTransaction = async (userId, partnerId, data) => {
    const ref = collection(
        db,
        "users",
        userId,
        "partners",
        partnerId,
        "transactions"
    );

    return await addDoc(ref, data);
};